/**
 * MobileHeader
 *
 * A sticky top-bar shown only on mobile (< 768px) when the sidebar is hidden.
 * Contains the LoopLogo, page context, and a hamburger button to open the sidebar.
 */

import { LoopLogo } from '../loop-ui';

interface MobileHeaderProps {
  onMenuToggle: () => void;
}

const HamburgerIcon = () => (
  <svg width={22} height={22} fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
  </svg>
);

const MobileHeader = ({ onMenuToggle }: MobileHeaderProps) => {
  return (
    <header className="loop-mobile-header">
      <button
        type="button"
        className="loop-mobile-header__toggle"
        onClick={onMenuToggle}
        aria-label="פתח תפריט"
      >
        <HamburgerIcon />
      </button>
      <LoopLogo height={28} />
    </header>
  );
};

export default MobileHeader;
